module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (useAdvancedFeaturesCheckbox) { 
__p+='\n<div class="filter-checkbox">\n    <label for="toggle-filters">\n        <input name="toggle-filters" id="toggle-filters" ';
 if (showFilters) { 
__p+='checked="true"';
 } 
__p+=' type="checkbox">\n        Advanced Features\n    </label>\n</div>\n';
 } 
__p+='\n<div class="filter-container fade" id="filter_container">\n    ';
 if (includeDateFilter) { 
__p+='\n    <label class="date-inline-fp" for="movein_date">\n        <input\n            type="text"\n            name="movein"\n            id="movein_date"\n            ';
 if (date) { 
__p+='\n            value="'+
((__t=( date ))==null?'':__t)+
'"\n            ';
 } 
__p+='\n            placeholder="Move-in Date"\n        />\n    </label>\n    ';
 } 
__p+='\n\n    <label class="maxrent-inline-fp" for="maxrent">\n        <input type="number" name="maxrent" id="maxrent" placeholder="Max Rent" />\n    </label>\n\n    ';
 checkLists.forEach(function(list) { 
__p+='\n    <div class="checklist-dropdown-inline-fp">\n        <a tabindex="0" class="checklist-label">'+
((__t=( list.name ))==null?'':_.escape(__t))+
'</a>\n        <div class="checklist-options">\n            <ul class="checklist-ul">\n                ';
 list.options.forEach(function(option) { 
__p+='\n                <li>\n                    <label for="'+
((__t=( option.id ))==null?'':__t)+
'">\n                        <input name="'+
((__t=( option.id ))==null?'':__t)+
'" id="'+
((__t=( option.id ))==null?'':__t)+
'" value="'+
((__t=( option.value ))==null?'':__t)+
'" type="checkbox" data-list="'+
((__t=( list.name ))==null?'':__t)+
'">\n                        '+
((__t=( option.value ))==null?'':_.escape(__t))+
'\n                    </label>\n                </li>\n                ';
 }) 
__p+='\n            </ul>\n        </div>\n    </div>\n    ';
 }) 
__p+='\n\n';
 if (!hideUnitNumbers) { 
__p+='\n<label class="unit-number-inline-fp" for="unitnumber">\n    <input name="unitnumber" id="unitnumber" placeholder="'+
((__t=( apartmentType ))==null?'':__t)+
' #" />\n</label>\n';
 } 
__p+='\n';
}
return __p;
};
